import { MongoObservable } from 'meteor-rxjs';
import { DocumentUpload } from '../models/documentUpload';

export const DocumentUploads = new MongoObservable.Collection<DocumentUpload>(
  'documentUploads',
);

DocumentUploads.allow({
  insert: function (userId, doc) {
    return !!userId && doc.userId === userId;
  },
  update: function () {
    return false;
  },
  remove: function (userId, doc) {
    return !!userId && doc.userId === userId;
  },
});
